import pTest from './index.vue'

export default {
  install(Vue) {
    Vue.component('pTest', pTest)
    // 添加实例方法
    Vue.prototype.$testFunc = function () {
      return 'Hello Vue'
    }
    // 添加实例属性
    Vue.prototype.$num = 0
    Object.defineProperty(Vue.prototype, '$testName', {
      get: function () {
        return 'hejikun'
      }
    })
  }
}
